<template>
  <div class="head">
    <div class="titleAuto">
      <div class="graytitle">
        <div class="div1" v-if="cityDetail.toCityChangeTitle">
          欢迎您进入{{
            deptName +
            (cityDetail.homeTitle
              ? cityDetail.homeTitle
              : "农村集体财产监督管理平台")
          }}
        </div>
        <div class="div1" v-else-if="cityDetail.homeTitle">
          欢迎您进入{{ cityDetail.cityName + cityDetail.homeTitle }}
        </div>
        <div class="div1" v-else>
          欢迎您进入{{ cityDetail.cityName }}农村集体财产监督管理平台
        </div>
        <div class="div2">
          今天是：{{ time }}
          <!-- <span style="margin-left: 100px">电话:0371-55088517</span> -->
        </div>
        <div class="div3">
          <!-- <span>手机app</span> -->
          <!-- <span>官方微信</span> -->
          <!-- <span>{{ this.place }}</span> -->
          <a
            v-if="cityDetail.backGroundUrl"
            target="_blank"
            :href="cityDetail.backGroundUrl"
            style="margin-left: 20px; color: rgb(112, 128, 144)"
            >登录后台</a
          >
          <div class="phone" v-if="phone" @click="openOperate">
            <span>{{ phone }}</span>
            <i class="el-icon-caret-top" v-if="showOperate"></i>
            <i class="el-icon-caret-bottom" v-else></i>
          </div>
          <div class="operate" v-if="phone">
            <el-badge
              :is-dot="$store.state.haveMessage"
              style="cursor: pointer"
            >
              <span class="operate1" @click="goUserInfo">个人中心</span>
            </el-badge>
            <span class="operate2" @click="quitLogin">退出登录</span>
          </div>
          <div v-if="!phone && !cityDetail.homeShowLogin" class="phone">
            <router-link to="/login" style="white-space: nowrap"
              >注册登录</router-link
            >
          </div>
          <!-- <router-link to="">12121</router-link> -->
        </div>
      </div>
    </div>
    <div
      class="title"
      :style="{
        background: `url('${cityDetail.homeBackImg}') no-repeat`,
        'background-size': '100% 100%',
      }"
    >
      <!-- 第一行 -->
      <div style="display: flex; align-items: center">
        <div
          class="imgDiv"
          v-if="
            cityDetail.cityName == '濮阳市华龙区' ||
            cityDetail.cityName == '濮阳市'
          "
        >
          <img class="img" src="../assets/img/logo.png" alt="" />
        </div>
        <span class="titleText">
          {{
            deptName +
            (cityDetail.homeTitle
              ? cityDetail.homeTitle
              : "农村集体财产监督管理平台")
          }}
        </span>
      </div>
      <!-- 第二行 -->
      <div
        style="
          display: flex;
          flex-flow: row;
          justify-content: center;
          align-items: center;
        "
        v-if="cityDetail.doubletitle"
      >
        <span class="titleText">
          <!-- {{
            cityDetail.toCityChangeTitle
              ? (sessionStorage.getItem("deptName")
                  ? sessionStorage.getItem("deptName")
                  : cityDetail.cityName) + cityDetail.doubletitleText
              : cityDetail.doubletitleText
              ? cityDetail.cityName + cityDetail.doubletitleText
              : cityDetail.cityName + "农村产权交易信息服务平台"
          }} -->
          {{
            cityDetail.doubletitleText
              ? deptName + cityDetail.doubletitleText
              : deptName + "农村产权交易信息服务平台"
          }}
          <!-- {{
            cityDetail.doubletitleText
              ? cityDetail.doubletitleText
              : cityDetail.cityName + "农村产权交易信息服务平台"
          }} -->
        </span>
      </div>
      <div
        class="titleText1"
        v-if="
          cityDetail.cityName == '濮阳市华龙区' ||
          cityDetail.cityName == '濮阳市'
        "
      >
        <span>唤醒农村沉睡资产</span>
        <span>增加农民资产性收入</span>
      </div>

      <!-- <div class="searchmodel">
        <el-input
          v-model="title"
          @keyup.enter.native="toQuanzhan()"
          placeholder="请输入关键字搜索">
          <i
            slot="suffix"
            class="el-input__icon el-icon-search"
            @click="toQuanzhan"></i>
        </el-input>
        <div
          class="qiehuan"
          style="display: flex; justify-content: end; align-items: center">
          <div>
            <span
              @click="currentIndex = 1"
              class="seachtext"
              :class="{ activestyle: currentIndex === 1 }"
              >找资讯</span
            >|
            <span
              @click="currentIndex = 2"
              class="seachtext"
              :class="{ activestyle: currentIndex === 2 }"
              >找项目</span
            >
          </div>
        </div>
      </div> -->
    </div>
    <div class="tabBarList">
      <div
        :class="{ tabBarAct: $route.path == tab.router }"
        class="tabBar"
        v-for="(tab, index) in tabList"
        :key="index"
        @click="goRouter(tab, index)"
        @mouseenter="showdetail(tab, index)"
        @mouseleave="hiddendetail(tab, index)"
      >
        <span
          :style="{
            'font-size': cityDetail.cityName == '辉县市' ? '26px' : '22px',
          }"
          >{{ tab.name }}</span
        >
        <div
          class="tabBarHover"
          @mouseenter="showdetail(tab, index)"
          @mouseleave="hiddendetail(tab, index)"
          v-if="tab.show && tab.type == 1"
        >
          <span
            v-for="(city, index) in placeList"
            :key="index"
            @click="tiaozhuan(city, 0, 0, 1)"
            v-if="
              placeList[0].level <=
              (cityDetail.deptId == cityDetail.lesseeId ? 3 : 4)
            "
          >
            {{ city.deptName }}
          </span>
        </div>

        <div
          class="tabBarHover1"
          @mouseenter="showdetail(tab, index)"
          @mouseleave="hiddendetail(tab, index)"
          v-if="tab.show && tab.type == 2"
        >
          <div class="label">
            <span
              v-for="(type, index) in typeList"
              :key="index"
              :class="{ typsAct: typeindex == index }"
              @click="typeindex = index"
            >
              {{ type.label }}
            </span>
          </div>
          <div v-for="(type, index) in typeList" :key="index">
            <div v-if="typeindex == index">
              <span
                @click="tiaozhuan(typeClass, idx, index, 2)"
                v-for="(typeClass, idx) in type.classList"
                :key="idx"
              >
                {{ typeClass.name }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getTownList, getTypeList } from '../api/Head'
import { getProList } from '../api/交易项目'
import { cityDetail } from '../util/mainOption'
export default {
  data () {
    return {
      cityList: [],
      typeindex: 0,
      left: 0,
      currentNav: 0,
      currentIndex: 1,
      title: '',
      nav: 1,
      typeActive: 10000,
      show: false,
      time: '',
      shouye: { name: '首页', index: 1 },
      nameList: [
        { name: '新闻中心', index: 2 },
        { name: '交易项目', index: 3 },
        { name: '资产招商', index: 5 },
        { name: '交易指南', index: 6 },
        { name: '政策法规', index: 7 },
        { name: '资料下载', index: 8 },
        { name: '关于我们', index: 9 },
      ],
      tabIndex: 0,
      tabList: this.cityDetail.tabList,
      // typeList: [{ name: '承包地', number: '001' }, { name: '四荒地', number: '002' }, { name: '实物资产', number: '003' }, { name: '养殖水面', number: '004' }, { name: '林地林木', number: '005' }, { name: '闲置宅基地', number: '006' }, { name: '知识产权', number: '008' }, { name: '招投标', number: '009' }, { name: '其他', number: '010' }, { name: '房屋所有权', number: '011' }, { name: '生产性设施', number: '007' }, { name: '建设用地', number: '012' }],
      placeList: [],
      // activeList: [],
      place: this.cityDetail.cityName,
      Timeout: '',
      type: '',
      // 是否展示个人中心操作弹窗
      showOperate: false,
      // 首页展示电话号
      phone: '',
      showDetail1: false,
      typeList: [
        {
          label: '供应项目',
          type: 2,
          classList: [],
        },
        {
          label: '需求项目',
          type: 3,
          classList: [],
        },
        {
          label: '招投标项目',
          type: 1,
          classList: [],
        },
      ],
      deptName: "",
    }
  },

  destroyed () {
    clearTimeout(this.Timeout)
  },
  computed: {
    isLogin () {
      return this.$store.state.isLogin
    }
  },
  watch: {
    isLogin (val, oldVal) {
      if (val == true) {
        let phone = localStorage.getItem('phone')

        if (phone) {
          let head = phone.slice(0, 3)
          let foot = phone.slice(7, 11)
          this.phone = head + '****' + foot
        }
      }
    },
    $route: {
      handler: function (val, oldVal) {
        //   console.log(val.name);
        this.checkluyou(val.name)
        //   console.log(oldVal);
        // if()
      },
      // 深度观察监听
      deep: true,
      deptName: '',
    },
  },
  created () {
    this.deptName = this.$route.query.deptName
      ? this.$route.query.deptName
      : this.cityDetail.cityName
    setTimeout(() => {
      let culuyouname = this.$route.name
      // console.log(culuyouname)
      this.checkluyou(culuyouname)
    }, 1000)
    let phone = localStorage.getItem('phone')

    if (phone) {
      let head = phone.slice(0, 3)
      let foot = phone.slice(7, 11)
      this.phone = head + '****' + foot
    }
  },
  // computed:{
  //     routename(){
  //         return this.$route.name
  //     }
  // },
  mounted () {
    this.deptName = cityDetail.toCityChangeTitle ? (sessionStorage.getItem("deptName") ? sessionStorage.getItem("deptName") : cityDetail.cityName) : cityDetail.cityName
    this.time = this.today()

    // this.Timeout = setTimeout(() => {
    this.place = sessionStorage.getItem('place')
    // }, 2000)
    getTownList().then((res) => {
      // console.log(res)
      this.placeList = res.data.data
    })

    for (let i = 0, j = this.typeList.length; i < j; i++) {
      getProList({ type: this.typeList[i].type }).then((res) => {
        this.typeList[i].classList = res.data.data
      })
    }
    console.log(this.typeList, '类型列表')
  },

  methods: {
    showdetail (tab = {}, index) {

      // if (index) {
      this.tabIndex = index
      this.cityDetail.tabList[index].show = true
      // } else {
      //   this.cityDetail.tabList[this.tabIndex].show = true
      // }
      this.$forceUpdate()
    },
    hiddendetail (tab = {}, index = 0) {
      if (index) {
        this.tabIndex = index
        this.cityDetail.tabList[index].show = false
      } else {
        this.cityDetail.tabList[this.tabIndex].show = false
      }
      this.$forceUpdate()
    },
    showdetail1 (tab = {}, index = 0) {
      this.showDetail1 = true
    },
    hiddendetail1 () {
      this.showDetail1 = false
    },
    // 跳转路由
    goRouter (tab, i) {
      console.log("跳转", tab)
      if (!tab.type) {
        if (tab.andCity) {
          this.$router.push({
            path: tab.router,
            query: {
              deptName: sessionStorage.getItem('deptName'),
              deptCode: sessionStorage.getItem('deptCode'),
              deptId: sessionStorage.getItem('deptId') ? sessionStorage.getItem('deptId') : cityDetail.deptId,
            },
          })
        } if (tab.href) {
          window.open(tab.href)
        } else {
          this.$router.push(tab.router)
        }
      }
    },
    // 进入个人中心页面
    goUserInfo () {
      this.$router.push('/personal')
      this.showOperate = false
      this.$store.state.haveMessage = false
    },
    // 展开操作弹窗
    openOperate () {
      this.showOperate = !this.showOperate
    },
    // 获取所在区域列表
    getList (num) {
      this.type = num == 1 ? '所在区域' : '交易类型'
    },
    // 退出按钮事件
    quitLogin () {
      localStorage.removeItem('token')
      localStorage.removeItem('phone')
      sessionStorage.removeItem('deptId')
      this.$message.success('退出登录成功')

      this.$router.push('/')
      location.reload()
    },

    //判断当前路由是不是上面那一列的
    checkluyou (culuyouname) {
      if (culuyouname == '首页') {
        this.currentNav = 1
      } else {
        let arr = this.nameList.map((item) => item.name)
        if (!arr.includes(culuyouname)) {
          this.currentNav = 0
        } else {
          this.nameList.forEach((item) => {
            if (item.name == culuyouname) {
              this.currentNav = item.index
            }
          })
        }
      }
    },
    //跳转到首页
    toShouye () {
      this.nav = 1
      this.$router.push({ name: '首页' })
    },
    goshouye (item) {
      if (this.$route.name == item.name) {
        return
      }
      this.currentNav = item.index
      if (item.index == 4) {
        let url = this.requestUrl + 'index/bidding/login.html'
        window.open(url, '_blank')
      } else if (item.index == 3) {
        //去交易项目时候
        let currentDizhi = sessionStorage.getItem('xiandm')
        // console.log(currentDizhi);
        if (currentDizhi) {
          this.$router.push({ name: item.name, query: { dm: currentDizhi } })
        } else {
          this.$router.push({ name: item.name })
        }
      } else {
        this.$router.push({ name: item.name })
      }
      this.currentNav = item.index
    },
    goshouye1 (item) {
      if (this.$route.name == item.name) {
        return
      }
      this.currentNav = item.index
      // console.log(this.$route);
      this.$router.push({ name: item.name })
      this.currentNav = item.index
      sessionStorage.setItem('place', cityDetail.cityName)
      sessionStorage.setItem('xiandm', '')
    },
    //跳转到新闻中心
    toXinwen () {
      this.nav = 2
      this.$router.push({ name: '新闻中心' })
    },
    toQuanzhan () {
      this.$router.push({
        name: '全站搜索',
        query: { keyword: this.title, type: this.currentIndex },
      })
    },
    today () {
      var d = new Date(),
        show_day = new Array(
          '星期日',
          '星期一',
          '星期二',
          '星期三',
          '星期四',
          '星期五',
          '星期六'
        ),
        day = d.getDay(),
        str = ''
      str += d.getFullYear() + '年' //获取当前年份
      str += d.getMonth() + 1 + '月' //获取当前月份（0——11）
      str += d.getDate() + '日'
      str += ' ' + show_day[day]
      return str
    },
    tojiaoyi (type, index) {
      // console.log(type, index);
      this.currentNav = 3
      // this.$router.push({ name: '交易项目', query: { id: i, dm: this.dm, number: this.number } });
      this.$router.push({
        name: '交易项目',
        query: { id: index + 1, dm: '', number: type.dictSort },
      })
    },
    dayin () {
      // console.log(111)
    },
    tiaozhuan (go = {}, idx = 0, index = 0, type = 0) {
      if (type == 1) {
        // 打开新的网页
        if (go.level > 4) {
          return
        }
        if (go.level >= 3 && go.parentId) {
          let notGo = cityDetail.notGoCityList ? cityDetail.notGoCityList : []
          if (!(notGo.find(item => item == go.deptName))) {
            window.open(
              (location.href.indexOf("?") >= 0 ? location.href.split("?")[0] : location.href) +
              `?dm=${go.deptId}&deptName=${go.deptName}&deptCode=${go.deptCode}&parentId=${go.parentId}`
            )
          }
        }
        this.currentNav = 0
      } else if (type == 2) {
        this.$router.push({
          name: '交易项目',
          query: { idx: Number(idx) + 1, index },
        })
        if (this.$route.name == '交易项目') {
          location.reload()
        }
      }
    },
  },
  // created() {
  // },
}
</script>

<style scoped>
* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}
.title {
  width: 100%;
  height: 363px;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;
}

.imgDiv {
  position: relative;
  width: 130px;
  height: 140px;
  margin-right: 40px;
}
.imgDiv > .img {
  width: 100%;
  height: 100%;
}
.titleText {
  font-family: Source Han Sans;
  font-size: 80px;
  font-weight: bold;
  color: #ffffff;
  letter-spacing: 16px;
  height: 90px;
  line-height: 90px;
  white-space: nowrap;
  text-align: center;
  text-shadow: 1px 1px 1px #919191, 1px 2px 1px #919191, 1px 3px 1px #919191,
    1px 4px 1px #919191, 1px 5px 1px #919191, 1px 12px 6px rgba(10, 10, 10, 0.4),
    1px 14px 6px rgba(10, 10, 10, 0.2), 1px 16px 10px rgba(10, 10, 10, 0.2),
    1px 18px 35px rgba(10, 10, 10, 0.2), 1px 20px 60px rgba(10, 10, 10, 0.2);
}
.titleText1 {
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 1000px;
}
.titleText1 > span {
  font-size: 56px;
  color: #fff;
  font-family: kaiti;
  font-weight: 600;
  text-shadow: 1px 1px 1px #919191, 1px 2px 1px #919191, 1px 3px 1px #919191,
    1px 4px 1px #919191, 1px 5px 1px #919191, 1px 10px 6px rgba(10, 10, 10, 0.4),
    1px 12px 6px rgba(10, 10, 10, 0.4), 1px 14px 10px rgba(10, 10, 10, 0.4),
    1px 16px 35px rgba(10, 10, 10, 0.2), 1px 18px 60px rgba(10, 10, 10, 0.2);
}
.tabBarList {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #2187ff;
  position: relative;
}
.tabBar {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  width: 210px;
  cursor: pointer;
  color: #fff;
  position: relative;
}
.tabBarHover {
  display: block;
  width: 450px;
  height: auto;
  position: absolute;
  top: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 200;
  left: 0%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  padding: 0 10px;
}
.tabBarHover > span {
  text-align: center;
  padding: 10px 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.tabBarHover > span:hover {
  color: #2187ff;
}
.tabBarHover1 {
  display: block;
  width: 450px;
  height: auto;
  position: absolute;
  top: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 200;
  left: 0%;
  padding: 10px;
  display: flex;
  flex-direction: column;
}
.tabBarHover1 > .label {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
}
.tabBarHover1 > .label > span {
  text-align: center;
}
.typsAct {
  color: #2187ff;
}
.tabBarHover1 > div > span {
  font-size: 20px;
  font-weight: bold;
  padding: 10px 0;
}
.tabBarHover1 > div > div {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
}
.tabBarHover1 > div > div > span {
  text-align: center;
  padding: 10px 0;
}
.tabBarHover1 > div > div > span:hover {
  color: #2187ff;
}
.tabBarAct {
  color: #2187ff;
  background-color: #fff;
}
.tabBar > span {
  white-space: nowrap;
}
.type {
  color: #fff;
  font-size: 20px;
  padding: 10px 0;
}

.typeTit {
  font-size: 24px;
  font-weight: bold;
  cursor: pointer;
}

.typeTit:hover {
  color: #2187ff;
}

.classList {
  display: grid;
  grid-template-columns: 25% 25% 25% 25%;
  margin-top: 6px;
}

.classSpan {
  text-align: center;
  padding: 6px 0;
  cursor: pointer;
}

.classSpan:hover {
  color: #2187ff;
}

.seachtext {
  color: #fff;
  cursor: pointer;
}

/* .allmess {
    height: 45px;
    cursor: pointer;
    line-height: 45px;
    font-size: 30px;
    width: 415px;
    text-align: center;
    color: #fff;
} */
.allmess {
  cursor: pointer;
  flex: 1;
  text-align: center;
}

.allmess1 {
  cursor: pointer;
  flex: 1;
  text-align: center;
}

.searchmodel /deep/.el-input {
  font-size: 22px;
  /* border: 1px solid red; */
  text-align: right;
}

.searchmodel /deep/.el-input__inner {
  height: 50px;
  width: 300px;
  border: 1px solid #747474;
  border-radius: 10px;
  /* font-size: 16px; */
}

.searchmodel {
  /* margin-left: 500px; */
  position: absolute;
  right: 100px;
  top: 20px;
}

.zhongwen {
  font-size: 60px;
  /* color: #6681EA; */
  font-weight: 600;
  letter-spacing: 10px;
  white-space: nowrap;
  color: white;
}

.baise {
  color: white;
}

.pinyin {
  /* color:#848484; */
  /* color: #fff; */
  font-size: 16px;
}

.qiehuan {
  font-size: 20px;
  text-align: right;
  width: 100%;
}

.el-icon-search {
  color: #2187ff;
  cursor: pointer;
  font-size: 25px;
}

.el-input__icon {
  line-height: 50px;
  width: 40px;
}

.graytitle {
  width: 1860px;
  height: 50px;

  font-size: 20px;
  color: rgb(112, 128, 144);
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
}

.titleAuto {
  background-color: #efefef;
  border-bottom: 1px solid #ccc;
  width: 100%;
  display: flex;
  justify-content: center;
}

.div1 {
  width: auto;
  min-width: 330px;
  /* border: 1px solid red; */
  white-space: nowrap;
}

.div2 {
  width: 610px;
  min-width: 610px;
  /* border: 1px solid red;   */
  margin-left: 130px;
}

.div3 {
  margin-left: 180px;
  /* min-width: 180px; */
  /* width: 180px; */
  display: flex;
  align-items: center;
  position: relative;
}

.phone {
  padding-left: 12px;
  //border-left: 1px solid rgb(112, 128, 144);
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
}

.phone > span {
  font-size: 20px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: rgb(112, 128, 144);
  margin-right: 12px;
}

.phone > a {
  font-size: 20px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: rgb(112, 128, 144);
  margin-right: 12px;
}

.operate {
  position: absolute;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  padding: 10px 16px;
  border-radius: 8px;
  top: 140%;
  right: 35px;
  z-index: 1000;
}

.operate > span {
  font-size: 20px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #404040;
  cursor: pointer;
}

.operate1 {
  padding-bottom: 8px;
  border-bottom: 1px solid #404040;
  white-space: nowrap;
}

.operate2 {
  padding-top: 8px;
  white-space: nowrap;
}

.el-icon-caret-bottom {
  font-size: 20px;
}

.el-icon-caret-top {
  font-size: 20px;
}

.div3 > a {
  margin-left: 20px;
  white-space: nowrap;
  margin-right: 12px;
}

.toshouye {
  cursor: pointer;
  padding: 0 20px;
}

.activeNav1 {
  /* color: #262626; */
  padding: 0 23px;
  text-decoration: none;
  font-weight: 500;
  border-bottom: 5px solid white;
  font-weight: bold;
  /* background-color: #6681EA; */
  color: white;
}

.clickname:hover {
  color: #2187ff;
}

.activeNav {
  /* color: #262626; */
  padding: 0 23px;
  text-decoration: none;
  user-select: none;
  cursor: pointer;
  /* background-color: #6681EA; */
  color: white;
}

.activeNav:hover {
  font-weight: bold;
}

.toshouye:hover {
  color: #262626;
  padding: 0 20px;
  text-decoration: none;
  font-weight: 500;
  border-bottom: 5px solid white;
  font-weight: bold;
}

.activestyle {
  color: red;
  /* color: #6681EA; */
}

.bar {
  display: flex;
  /* border: red 1px solid; */
  height: 45px;
  margin: 0 auto;
  margin-top: 10px;
  width: 1864px;
  font-size: 24px;
  /* margin-top: 10px; */
  position: relative;
}

.router {
  color: black;
  text-decoration: none;
  padding: 0 20px;
  font-weight: 500;
}

.router-link-active {
  color: black;
  padding: 0 20px;
  text-decoration: none;
  font-weight: 500;
  border-bottom: 3px solid #2187ff;
  font-weight: bold;
}

.nav {
  color: #444;
  /* border: 1px solid green; */
  padding-left: 10px;
  font-size: 30px;
  display: flex;
  /* background-color: #6681EA; */
}

.time {
  /* padding: 0 5px; */
  width: 1300px;
  height: 30px;
  margin: 0 auto;
  overflow: hidden;
  color: rgb(123, 123, 123);
  position: relative;
  line-height: 30px;
}

.time > :nth-child(1) {
  font-size: 14px;
  position: absolute;
  left: 0%;
  top: 0;
}

.time > :nth-child(2) {
  font-size: 14px;
  position: absolute;
  top: 0;
  right: 13%;
}

.tiaozhuan {
  text-decoration: none;
  color: white;
  font-size: 20px;
  line-height: 30px;
  border: 0;
  padding: 0;
  font-weight: normal;
  margin: 0px 5px;
}
</style>
